import React from "react";
import "./button.css";

const DeleteDuplicatesButton = ({ onClick }) => {
  return (
    <button className="delete-duplicates-btn" onClick={onClick}>
      Delete Duplicates
    </button>
  );
};

export default DeleteDuplicatesButton;